module.exports = __webpack_public_path__ + "static/media/down_arrow.2d156973.svg";